import QrReader from "react-qr-reader-es6";

interface Props {
  onScanHandler: (data?: string) => void;
}

const delay = 100;

export function QrCodeReader({ onScanHandler }: Props) {
  const handleScan = (data: string | null) => {
    if (data) {
      onScanHandler(data);
    }
  };

  const handleError = (err: unknown) => {
    console.error(err);
  };

  return <QrReader delay={delay} onError={handleError} onScan={handleScan} />;
}
